import React, { Component } from 'react';
import PropTypes from 'prop-types';
import NestedUtils from './../multistep-select/NestedUtils';

class SelectedItems extends Component {

    constructor(props)
    {
        super(props);
    }

    generateItemName(item) {
        const data = this.props.nestedUtils.orderFromParentsToChildren(item.id);

        const names = data.map(item => item.name);

        return names.join(' \u2023 ');
    }

    render() {
        const items = this.props.nestedUtils
            .findByIds(this.props.selection);

        const list = items.map(item => {
            return (
                <div key={item.id} className="row pt-2">

                    <div className="col-10">
                        <i className="fa fa-check-circle-o" aria-hidden="true"/> {this.generateItemName(item)}
                    </div>

                    <div className="col-2">
                        <button role="button"
                                title={this.props.deleteButtonText}
                                className="btn btn-danger btn-m"
                                onClick={() => this.props.onRemove(item)}>

                            <i className="fa fa-trash-o" aria-hidden="true"/>
                            {this.props.deleteButtonText}
                        </button>
                    </div>

                </div>
            )
        });

        if (items.length) {
            return <div>{list}</div>;
        } else {
            return null;
        }
    }
}
SelectedItems.propTypes = {
    nestedUtils: PropTypes.instanceOf(NestedUtils).isRequired,
    selection: PropTypes.array.isRequired,
    onRemove: PropTypes.func.isRequired,
    deleteButtonText: PropTypes.string,
};

export default SelectedItems;


// WEBPACK FOOTER //
// ./web/src/components/supplier-competencies/SelectedItems.jsx